import React, { SyntheticEvent } from 'react';
import cx from 'classnames';

import { getTailwindColor, scaleImage } from '@trqk/utils';

const iconId = 'statement-history';

const originalDimensions = {
    width: 288.5,
    height: 275.8,
};

// built from the same image as packages/web/src/assets/svg/insights-empty-statement.svg

export const IconStatementHistory = (props: IconProps): JSX.Element => {
    const fillColor = props?.fillColor ?? 'black';
    const fill = getTailwindColor(fillColor);
    const { height, width } = scaleImage(originalDimensions, props);
    const { addClasses, handleClick } = props;
    const classNames = cx(addClasses, 'inline', {
        'cursor-pointer': handleClick,
    });

    return (
        <svg
            aria-labelledby={iconId}
            className={classNames}
            height={height}
            onClick={(e: SyntheticEvent): void => {
                if (handleClick) {
                    handleClick(e);
                }
            }}
            viewBox={`0 0 ${originalDimensions.width} ${originalDimensions.height}`}
            width={width}
            xmlns="http://www.w3.org/2000/svg"
        >
            <title id={iconId}>Statement History Icon</title>
            <path
                d="M256.3 275.8H38.1c-7 0-12.7-5.7-12.7-12.7V12.7c0-7 5.7-12.7 12.7-12.7h218.2c7 0 12.7 5.7 12.7 12.7V263c0 7-5.7 12.8-12.7 12.8z"
                fill={fill}
                opacity="0.3"
            />
            <linearGradient
                id="a"
                gradientUnits="userSpaceOnUse"
                x1="147.199"
                y1="275.777"
                x2="147.199"
                y2="61.662"
            >
                <stop offset="0" stopColor={fill} stopOpacity=".1" />
                <stop offset="1" stopColor={fill} />
            </linearGradient>
            <path
                d="M242.3 61.7L135.7 191l-59.4-43.1-50.9 52.4V263c0 7 5.7 12.7 12.7 12.7h218.2c7 0 12.7-5.7 12.7-12.7V91.5l-26.7-29.8z"
                opacity=".55"
                fill="url(#a)"
            />
            <path
                d="M286.8 98.7l-39.7-44.2c-1.2-1.4-3-2.2-5-2.2-1.9 0-3.7.9-4.9 2.4L134.5 179.3 80 139.8c-2.6-1.9-6.2-1.6-8.5.7L1.8 212.3c-1.2 1.2-1.9 2.9-1.8 4.6 0 1.7.7 3.4 2 4.6 1.2 1.2 2.8 1.8 4.5 1.8 1.8 0 3.4-.7 4.7-2L77 153.6l54.9 39.8c2.8 2 6.6 1.5 8.8-1.1L242.5 68.8l34.6 38.6c2.4 2.7 6.5 2.9 9.2.5 2.7-2.4 2.9-6.5.5-9.2z"
                fill={fill}
            />
        </svg>
    );
};
